import { FC, useMemo } from "react";
import { useHistory } from "react-router";

import { IUser } from "Auth/types";
import { Navbar as Component } from "shared/components";
import { PATHS } from "App/router";
import { copy } from "shared/assets";

interface NavbarProps {
  currentUser?: IUser;
}

export const Navbar: FC<NavbarProps> = ({ currentUser }) => {
  const history = useHistory();

  const navItems = useMemo(
    () =>
      currentUser
        ? [
            {
              to: PATHS.DASHBOARD,
              label: copy.dashboard.title,
            },
          ]
        : [],
    [currentUser]
  );

  return (
    <Component
      title={copy.title.venues}
      navItems={navItems}
      currentUser={currentUser}
      profilePagePath={PATHS.DASHBOARD}
      homePagePath={PATHS.HOME}
      currentPath={history.location.pathname}
    />
  );
};
